<template>
  <div class="retailer-detail-fi">
    <div
      v-if="retailer.Names[0]"
      class="retailer-detail-fi__name"
    >
      {{ retailer.Names[0] }}
    </div>
    <div
      v-if="retailer.Names[1]"
      class="retailer-detail-fi__subname"
    >
      {{ retailer.Names[1] }}
    </div>

    <div
      v-if="retailer.RetailerTypeList?.length"
      class="retailer-detail-fi__address__retailer-type"
    >
      {{ retailer.RetailerTypeList.join(', ') }}
    </div>

    <div class="retailer-detail-fi__address">
      <icon-fi
        icon="store"
        class="retailer-detail-fi__address__icon"
      />
      <div class="retailer-detail-fi__address__data">
        <div v-if="retailer.Address?.AddressLines?.[0]">
          {{ retailer.Address.AddressLines[0] }}
        </div>
        <div v-if="retailer.Address?.PostalCode">
          {{ retailer.Address.PostalCode }} {{ retailer.Address.City }}
        </div>
      </div>
    </div>

    <availability-indicator
      v-if="showStock"
      class="retailer-detail-fi__stock"
      :is-stocked="isStocked"
    />

    <div
      v-if="retailer.Contact"
      class="retailer-detail-fi__contact"
    >
      <contact-detail-fi
        v-if="retailer.Contact.Phone"
        icon="phone-call"
        :href="getTel(retailer.Contact.Phone)"
        :detail="retailer.Contact.Phone"
      />
      <contact-detail-fi
        v-if="retailer.Contact.Fax"
        icon="printer"
        :href="getFax(retailer.Contact.Fax)"
        :detail="retailer.Contact.Fax"
      />
      <contact-detail-fi
        v-if="retailer.Contact.Email"
        icon="mail"
        :href="getMailto(retailer.Contact.Email)"
        :detail="retailer.Contact.Email"
      />
      <contact-detail-fi
        v-if="retailer.Contact.Url"
        icon="globe"
        :detail="retailer.Contact.Url"
        :href="retailer.Contact.Url"
        target="_blank"
      />
    </div>

    <div class="retailer-detail-fi__navigation">
      <div
        class="retailer-detail-fi__navigate-to"
        @click="navigateTo"
      >
        <icon-fi
          icon="map-pin"
          class="retailer-detail-fi__navigation__icon"
        />
        {{ $dict.get('dealer-Locator.Start-Navigation') }}
      </div>

      <div
        class="retailer-detail-fi__google-maps"
        @click="openGoogleMaps(retailer)"
      >
        <icon-fi
          icon="google-map-pin"
          class="retailer-detail-fi__navigation__icon"
        />
        {{ $dict.get('dealer-Locator.Open-In-Google-Maps') }}
      </div>
    </div>
  </div>
</template>

<script>
import { AvailabilityIndicator, IconFi } from 'atoms';
import ContactDetailFi from 'components/retailer-search-fi/retailer-search-result-fi/ContactDetailFi';
import distanceMixin from 'mixins/distanceMixin';
import { getFaxHref, getMailToHref, getTelHref } from 'utils/linkHelper';

export default {
  name: 'RetailerDetailFi',
  components: {
    IconFi,
    AvailabilityIndicator,
    ContactDetailFi,
  },
  mixins: [distanceMixin],
  props: {
    retailer: {
      type: Object,
      required: true,
    },
    distance: {
      type: Number,
      default: null,
    },
    isStocked: Boolean,
    showStock: Boolean,
  },
  emits: ['navigate-to'],
  computed: {
    roundedDistance() {
      return this.roundDistance(this.distance);
    },
  },
  methods: {
    getTel(tel) {
      return getTelHref(tel);
    },
    getFax(fax) {
      return getFaxHref(fax);
    },
    getMailto(mail) {
      return getMailToHref(mail);
    },
    navigateTo() {
      this.$emit('navigate-to', {
        description: this.retailer.Names.join(', '),
        lat: this.retailer.Address.Latitude,
        lng: this.retailer.Address.Longitude,
      });
    },
    openGoogleMaps(retailer) {
      if (IS_SSR) {
        return;
      }

      const params = `${retailer.Address.AddressLines.join(', ')}, ${
        retailer.Address.City
      }, ${retailer.Names.join(', ')}`.replace(/\s/g, '+');
      const platform = navigator?.userAgentData?.platform;
      if (platform && ['iPhone', 'iPod', 'iPad'].some((el) => platform.includes(el))) {
        window.open(`maps://www.google.com/maps/search/?api=1&query=${params}`);
      } else {
        window.open(`https://www.google.com/maps/search/?api=1&query=${params}`);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import './retailer-detail-fi';
</style>
